import {
	GET_LEADERS_ORGANIZATION_CHART,
	GET_LEADERS_ORGANIZATION_CHART_ERROR,
	GET_LEADERS_ORGANIZATION_CHART_SUCCESS,
} from '../../constants';

export const getLeadersOrganizationChartRed = (state, actions) => {
	switch (actions.type) {
		case GET_LEADERS_ORGANIZATION_CHART:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_LEADERS_ORGANIZATION_CHART_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_LEADERS_ORGANIZATION_CHART_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				data: actions.payload,
			};
		default:
			return state;
	}
};
